class UpdateCartDiscounts 
{
  constructor(form) {
    this.form = form;
    this.init();
  }
  
  init() {
    fetch(`${window.Shopify.routes.root}cart.js`)
      .then(r => r.json())
      .then(json => {
        if (json.items.length) {
          this.update(json.items);
        }
      })
  }
  
  async update(line_items) {
    let discount_items = [];
    line_items.forEach(line_item => {
      let url = new URL('https://' + window.location.host + line_item.url);
      url.searchParams.set('view', 'discount.json');
      discount_items.push({ key: line_item.key, url: url.toString(), quantity: line_item.quantity })
    });
    const data = await Promise.all(discount_items.map(data=>this.fetchDiscount(data)));
    this.updateCart(data);
  }
  
  async fetchDiscount(data) {
    return new Promise((resolve) => {
      fetch(data.url)
        .then(r => r.json())
        .then(json => {
          resolve({ key: data.key, url: data.url, data: json, quantity: data.quantity });
        });
    })
  }
  
  async updateCart(data) {
    for (let index = 0; index < data.length; index++) {
      const isLastItem = index >= data.length - 1
      const item = data[index];
      const response = await fetch(`${window.themeVariables.routes.cartChangeUrl}.js`,
        {
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: {
              _discount: item.data.discount ? item.data.discount : '0',
              _graduated_prices: item.data.graduated_discount_data ? item.data.graduated_discount_data : '',
              _is_promotional_discount: item.data.is_promotional_discount ? item.data.is_promotional_discount : 'false',
              _hash: item.data.hash ? item.data.hash : '',
              _token: item.data.token ? item.data.token : '',
              _msg_conditional: item.data.msg_conditional ? item.data.msg_conditional : 'Conditional discount',
              _msg_graduated: item.data.msg_graduated ? item.data.msg_graduated : 'Graduated discount',
              _msg_promotional: item.data.msg_promotional ? item.data.msg_promotional : 'Promotional discount',
              _update_after_login: true,
            },
            sections: isLastItem ? ["mini-cart"] : []
          }),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
      if (isLastItem) {
        const cartContent = await response.json();
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: true,
          detail: {
            cart: cartContent
          }
        }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: cartContent,
            replacementDelay: 750
          }
        }));
        
        if (this.form) {
          document.documentElement.dispatchEvent(new CustomEvent("cart:discount:refreshed", {
            bubbles: true,
            detail: {
              form: this.form
            }
          }));
        }
        
        if (sessionStorage.getItem('checkout_redirect')) {
          const url = sessionStorage.getItem('checkout_redirect');
          sessionStorage.removeItem('checkout_redirect');
          if (url && url.includes('/checkout')) {
            fetch(`${window.Shopify.routes.root}?sections=mini-cart`)
              .then(res => res.json())
              .then(res => {
                const parser = new DOMParser();
                let html = parser.parseFromString(res["mini-cart"], "text/html");
                document.getElementById('shopify-section-mini-cart').innerHTML = html.getElementById('shopify-section-mini-cart').innerHTML;
                setTimeout(() => {
                  document.getElementById('mini-cart-form').submit();
                }, 10);
              }).catch(() => {
                window.location.href = url;
              });
          } else {
            window.location.href = window.Shopify.routes.root ? window.Shopify.routes.root : '/';
          }
        }
      }
    }
  }
}